import { FC } from 'react';
import Image from '@/Components/atoms/Image';
import Text from '@/Components/atoms/Text';
import Button from '@/Components/atoms/Button';
import Texts from '@/Components/molecules/Texts';
import { Props } from './ErrorCard.type';
import './ErrorCard.scss';
import { servizioClientiCta } from '@/utils/cta';
import { useTranslation } from 'react-i18next';

const ErrorCard: FC<Props> = props => {
  const { t } = useTranslation();

  return (
    <div className="error-card">
      <Image src={props.image} />
      <Texts types={['h3', 'p']} texts={[props.title, props.sutitle]} />
      {props.errorStatus === 500 && <Text type="p">{t('THANK_YOU.STATUS.ERROR_500')}</Text>}
      <Button onClick={servizioClientiCta} text={t('THANK_YOU.STATUS.CONTACT_CUSTOMER_SERVICE')} />
    </div>
  );
};

export { ErrorCard };
